import MilkType from "./MilkType";

export default function TbCS({data}) {
    // eslint-disable-next-line
    let lr = data.data;

    function SiloRow({num}){
      // eslint-disable-next-line
      let lbs = eval("lr.cs_cs"+num+"_lbs");
      // eslint-disable-next-line
      let temp = eval("lr.cs_cs"+num+"_temp");
      // eslint-disable-next-line
      let pa = eval("lr.cs_cs"+num+"_pa") === "Yes";
      // eslint-disable-next-line
      let mTypeId = eval("lr.cs_cs"+num+"_type");
      let mType = MilkType.find(x => x.id === 0);
      if (mTypeId === undefined) {
        if (pa) {
          mType = MilkType.find(x => x.id === 6);
        }
      }
      else {
        mType = MilkType.find(x => x.id === mTypeId);
      }
      return (
        <tr>
          <td className={mType.style}>CS {num} {mType.id > 0 && <sup>{mType.code}</sup>}</td>
          <td className={mType.style}>{lbs}</td>
          <td className={mType.style}>{temp}</td>
        </tr>
      )
    }

    return (
      <>
        <div className="card card-table mb-4 rounded-1 shadow-sm">
          <div className="card-header py-2">
            <h4 className="my-0">Condensed Skim</h4>
          </div>
          <div className="card-body nopadding">
            <table className="table table-sm my-0 tbl">
              <thead>
                <tr>
                  <th scope="col">Silo</th>
                  <th scope="col">Lbs</th>
                  <th scope="col">Temp</th>
                </tr>
              </thead>
              <tbody>
                <SiloRow num="1" />
                <SiloRow num="2" />
              </tbody>
            </table>
          </div>
        </div>

      </>
    )
}